import * as React from 'react';
import { ParagraphWidget } from '../forms/ParagraphWidget';
import { ButtonType, ButtonWidget } from '../buttons/ButtonWidget';
import { styled } from '../../theme';
import { DialogContentWidget } from './DialogContentWidget';

export interface ErrorDialogProps {
  title?: string;
  subTitle?: string;
  errorMessage: string;
  onContinue?: () => any;
}

export const ErrorDialog: React.FC<ErrorDialogProps> = (props) => {
  return (
    <DialogContentWidget
      title={props.title || 'Error'}
      subTitle={props.subTitle}
      isErrorDialog={true}
      footerContent={
        <S.Button
          type={ButtonType.SECONDARY}
          label={'OK'}
          action={() => {
            props.onContinue?.();
          }}
        />
      }>
      <S.ErrorPar>{props.errorMessage}</S.ErrorPar>
    </DialogContentWidget>
  );
};

namespace S {
  export const ErrorPar = styled(ParagraphWidget)`
    text-align: left;
  `;

  export const Button = styled(ButtonWidget)`
    min-width: 80px;
    border-color: ${(p) => p.theme.button.secondary.errorBorder};
    color: ${(p) => p.theme.button.secondary.errorBorder};
  `;
}
